// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"Layout_layoutContainer__1DUNY","pageContainer":"Layout_pageContainer__1cPvS","pageWrapper":"Layout_pageWrapper__cOcBo"};